import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";
import StaffForm from "../components/StaffForm";

export default function StaffEdit({ staff }: { staff: any }) {

    const saveStaff = (form: any) => {
        const requester = new Requester();

        const data = new FormData();

        Object.keys(form).forEach((key) => {
            data.append(key, form[key]);
        });

        requester.post(requester.getUrl(`api/staff/${staff.id}`), data).then((response) => {
            router.visit(`/admin/staff`);
        }).catch((error) => {
            alert("Error editing staff: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Staff" />
            <ContentWrapper>
                <StaffForm onSubmit={saveStaff} staff={staff} />
            </ContentWrapper>
        </App >
    )
}